import axios from 'axios'
import uuidv1 from 'uuid/v1'
import md5 from 'md5'

const { host, hostname, origin } = location

let urlRoot = ''
export const sjtuRoot = origin
let dialogStudio = false

let DOMAIN = 'talkinggenie.com'
if (/tgenie.cn/i.test(hostname)) {
  DOMAIN = 'tgenie.cn'
}

export const domain = DOMAIN

if (
  hostname === 'localhost' ||
  hostname === '0.0.0.0' ||
  hostname === '172.7.170.28' // `h5-dev.${domain}`
) {
  urlRoot = `https://beta.${domain}` // `https://h5-test.${domain}`
  // dialogStudio = true
} else if (
  host === `dev.${domain}` ||
  hostname === `dev.${domain}` ||
  hostname === `dev.${domain}`) {
  urlRoot = `https://dev.${domain}`
} else if (
  host === `test.${domain}` ||
  host === `beta.${domain}` ||
  host === `alpha.${domain}`
) {
  urlRoot = 'https://' + host.replace(/(test|beta|alpha)\./i, '$1.') // h5-$1.
  // sjtuRoot = `https://debugcheckdirect-test.${domain}`
  // dialogStudio = true
  // sjtuRoot = 'https://' + host.replace(/(test|beta|alpha)\./i, 'debugcheckdirect-$1.')
  // } else if (host === 'ba-h5-beta.dui.ai') {
  //   urlRoot = 'https://ba-h5-beta.dui.ai'
} else if (hostname === '120.55.100.86') {
  urlRoot = `https://www.${domain}`
  // sjtuRoot = `https://debugcheckdirect.${domain}`
  // dialogStudio = true
} else if (hostname === '10.12.6.216') {
  urlRoot = `http://10.12.6.216:19080`
} else if (hostname === '47.99.193.129') {
  urlRoot = `http://47.99.193.129:29083`
} else {
  urlRoot = `https://www.${domain}`
  // sjtuRoot = `https://debugcheckdirect.${domain}`
}

const uuid = uuidv1()
let userId
try {
  userId = localStorage.getItem('userId')
  if (!userId) {
    localStorage.setItem('userId', uuid)
    userId = uuid
  }
} catch (error) {
  userId = uuid
}

const instance = axios.create({
  withCredentials: false
})
const CancelToken = axios.CancelToken
const H5AxiosSource = {
  cancel: ''
}
const H5AxiosInput = {
  cancel: ''
}

// oauth授权校验
export const checkOauth = () => {
  const params = {}
  return axios.get(`${sjtuRoot}/ics-adapter/api/h5Adapter/checkOauth`, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res
  }).catch(err => {
    return Promise.reject(err)
  })
}
// oauth授权重定向
export const getOauth = (code) => {
  return axios
    .get(`${sjtuRoot}/ics-adapter/api/h5Adapter/oauth?code=${code}`)
    .then(res => {
      return res
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

export const getH5Config = configId => {
  return instance.get(`${urlRoot}/api/v1/h5Adapter/${configId}/configId/h5Config`).then(res => {
    return res.data
  }).catch(err => {
    return Promise.reject(err)
  })
}

// 上交大文本会话
export const sjtuSendH5Message = (inputText, productId) => {
  const recordId = md5(uuidv1())
  const params = {
    query: {
      type: 'text',
      text: inputText
    },
    context: {
      session: uuid + 'omZbzwQtW6Wa3I8Hntls3-dMv_Ns1521787587',
      recordId: recordId
    },
    dialog: {
      productId: productId + ''
    },
    output: {
      type: 'text'
    }
  }

  return instance
    .post(`${sjtuRoot}/ics-adapter/api/h5Adapter/text/message`, params, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': sessionStorage.getItem('token')
      }
    })
    .then(res => {
      return res.data
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

export const sendH5Message = (inputText, productId, ifResVoice, voiceId, speed, volume) => {
  const recordId = md5(uuidv1())
  const params = {
    product: {
      id: productId + ''
    },
    deviceType: 'mobile',
    userId: userId,
    externalSessionId: uuid + 'omZbzwQtW6Wa3I8Hntls3-dMv_Ns1521787587',
    account: 'simulation',
    recordId: recordId,
    solutionId: '100001',
    client_name: 'ba-h5',
    source: 'h5',
    h5Url: window.location.href,
    title: document.title,
    msg: {
      senderId: 'omZbzwQtW6Wa3I8Hntls3-dMv_Ns',
      receiverId: 'gh_b754b240c169',
      type: 'text',
      content: inputText,
      id: '6536027956702166076',
      time: '1521787596'
    }
  }
  if (ifResVoice) {
    params.output = {
      type: 'url',
      tts: {
        voiceId: voiceId,
        speed: speed,
        volume: volume
      },
      audio: {
        audioType: 'mp3'
      }
    }
  }

  return instance
    .post(`${urlRoot}/api/v1/h5Adapter/text/message`, params, {
      cancelToken: new CancelToken(function executor (c) {
        H5AxiosSource.cancel = c
      })
    })
    .then(res => {
      res.data.recordId = recordId
      return res.data
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

export const sendH5VoiceMessage = (blob, productId, ifResVoice, voiceId, speed, volume) => {
  const recordId = md5(uuidv1())
  const params = {
    product: {
      id: productId + ''
    },
    deviceType: 'pc',
    userId: userId,
    externalSessionId: uuid + 'omZbzwQtW6Wa3I8Hntls3-dMv_Ns1521787587',
    account: 'simulation',
    recordId: recordId,
    // "skillIds" : JSON.parse(storeProduct.skillIds),
    solutionId: '100001',
    client_name: 'ba-h5',
    source: 'h5',
    h5Url: window.location.href,
    title: document.title,
    msg: {
      senderId: 'omZbzwQtW6Wa3I8Hntls3-dMv_Ns_1',
      receiverId: 'gh_b754b240c169_1',
      asr: {
        res: 'comm'
      },
      type: 'file',
      // "content": inputText,
      id: '6536027956702166075',
      time: '1521787597',
      mediaid: 'fdafdsf',
      format: 'mp3',
      audio: {
        audioType: 'mp3',
        sampleRate: 16000,
        channel: 1,
        sampleBytes: 2
      }
    }
  }
  if (ifResVoice) {
    params.output = {
      type: 'url',
      tts: {
        voiceId: voiceId,
        speed: speed,
        volume: volume
      },
      audio: {
        audioType: 'mp3'
      }
    }
  }

  const fd = new FormData()
  fd.append('fileName', blob, `${recordId}.wav`)
  return instance
    .post(`${urlRoot}/api/v1/h5Adapter/voice/message`, fd, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      params: {
        param: params
      },
      cancelToken: new CancelToken(function executor (c) {
        H5AxiosSource.cancel = c
      })
    })
    .then(res => {
      return res.data
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

// 获取客户端
export const appSource = () => {
  let u = navigator.userAgent
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  let isIOS = navigator.userAgent.match(/iPhone|iPad|iPod/gi)
  let isMobile = isIOS || navigator.userAgent.match(/Android|BlackBerry|Opera Mini|IEMobile/gi)

  if (isMobile) {
    if (isIOS) {
      return 'ios'
    } else if (isAndroid) {
      return 'andriod'
    }
  } else {
    return 'web'
  }
}

// 输入联想
export const getInputQuick = (productId, content) => {
  return instance({
    methods: 'get',
    url: `${urlRoot}/api/v2/knowledge/quick/one`,
    params: { productId, content },
    cancelToken: new CancelToken(function executor (c) {
      H5AxiosInput.cancel = c
    }),
    headers: {
      authToken: 'e2da590263976ad33144deda87c1824e'
    }
  }).then(res => {
    return res.data.result
  }).catch(err => {
    return Promise.reject(err)
  })
}

// 获取常见问题
export const getFaqList = (productId) => {
  return instance({
    headers: {
      authToken: 'e2da590263976ad33144deda87c1824e'
    },
    method: 'get',
    url: `${urlRoot}/api/v2/faqManager/${productId}/product/faq/subject`
  }).then(res => {
    const { data } = res
    if (data.code === '200') {
      return data.result
    }
    return data
  })
}

// 查询常见问题的标题
export const getTitle = (id) => {
  return instance({
    url: `${urlRoot}/api/v2/faqManager/${id}/faq/subject/title`,
    method: 'GET',
    headers: {
      authToken: 'e2da590263976ad33144deda87c1824e'
    }
  }).then(res => {
    const { data } = res
    if (data.code === '200') {
      return data.result
    }
    return data
  })
}

// 回复的正负反馈收集
export const getJudge = params => {
  return instance({
    url: `${urlRoot}/api/v1/h5Adapter/judge`,
    method: 'POST',
    params: params,
    headers: {
      authToken: 'e2da590263976ad33144deda87c1824e'
    }
  }).then(res => {
    const { data } = res
    if (data.code === '200') {
      return data.result
    }
    return data
  })
}
// 查询公告
export const getNotice = productId => {
  return instance({
    url: `${urlRoot}/api/v3/product/notice/${productId}`,
    method: 'GET',
    headers: {
      authToken: 'e2da590263976ad33144deda87c1824e'
    }
  }).then(res => {
    const { data } = res
    if (data.code === '200') {
      return data.result
    }
    return data
  })
}
// 查询功能导航
export const getNavigation = productId => {
  return instance({
    url: `${urlRoot}/api/v3/navi/${productId}`,
    method: 'GET',
    headers: {
      authToken: 'e2da590263976ad33144deda87c1824e'
    }
  }).then(res => {
    const { data } = res
    if (data.code === '200') {
      return data.result
    }
    return data
  })
}

const SJTUTaskCenter = {}
window.SJTUTaskCenter = SJTUTaskCenter
export default SJTUTaskCenter

export { H5AxiosSource, H5AxiosInput }

// 是否是无logo体验版
export const DIALOG_STUDIO = dialogStudio



// WEBPACK FOOTER //
// ./src/app/Service/api.js